
window.whitelistSite = 'AMN'

export function setWhitelistSite (value) {
  window.whitelist = value
}

/**
 * Constant strings to use within the app for whitelisting the website
 */
const Strings = {
  getSite: () => {
    return Strings[window.whitelistSite]
  },
  AMN: {
    appbarTitle: 'AMN'
  },
  SiteTwo: {
    appbarTitle: 'Site 2'
  }
}

export default Strings
